class InvalidArgumentsException extends Error {
  constructor(message) {
    super(`${message}, pass at least one implementation to LoginManager`);

    this.name = 'InvalidArgumentsException';
    this.details =
      'You Should pass at least one of these implementation to LoginManager\n1. SeamlessLoginImplementation\n2. SoftLoginImplementation\n3. UpfrontLoginImplementation and pass null value instead of ';
  }
}

class SeamlessAmbiguityException extends Error {
  constructor(message) {
    super(
      `${message}, SeamlessLogin cannot be used alone, It should be used with SoftLogin or UpfrontLogin or both`,
    );

    this.name = 'SeamlessAmbiguityException';
    this.details =
      'SeamlessLogin cannot be used alone with wifi, SeamlessLogin can be used with other types of login or alone with mobile data';
  }
}

export { InvalidArgumentsException, SeamlessAmbiguityException };
